import React from "react";
import styles from "./TranscriptTableRow.module.css";
import classnames from "classnames";
import {TranscriptInListDTO} from "../../../../../api/generated";
import {Link} from "react-router-dom";
import {formatDateTime} from "../../../../../utils/dateTimeUtil";
import {CopyField} from "../../../../elements/copyField/CopyField";
import {ChatOutcomeCell} from "./cell/chatOutcome/ChatOutcomeCell";
import {FollowUpCell} from "./cell/followUp/FollowUpCell";
import {ConversationChannelIcon} from "../../../../elements/conversationChannelIcon/ConversationChannelIcon";

interface TranscriptTableRowProps {
    index: number
    transcript: TranscriptInListDTO
    isLastRow: boolean
}


export const TranscriptTableRow: React.FC<TranscriptTableRowProps> = ({index, transcript, isLastRow}) => {

    const {date, time} = formatDateTime(transcript.startedAt)
    const transcriptLink = `/transcripts/${transcript.publicBotId}/${transcript.userId}?conversationChannel=${transcript.conversationChannel}`;

    return <div key={index} className={classnames(styles.wrapper, isLastRow && styles.lastRow)}>
        <div className={styles.chunnelCell}>
            <ConversationChannelIcon conversationChannel={transcript.conversationChannel}/>
        </div>
        <Link className={styles.customerCell} to={transcriptLink}>{transcript.userName ?? "Not Provided"}</Link>
        <span className={styles.dateTimeCell}><span>{date}</span><span>{time}</span></span>
        <div className={styles.contactInformationCell}>
            <CopyField value={transcript.userEmail}/>
            <CopyField value={transcript.userPhoneNumber}/>
        </div>
        <ChatOutcomeCell chatEvents={transcript.chatEvents}/>
        <FollowUpCell chatEvents={transcript.chatEvents}/>
    </div>
}
